module.exports = __webpack_public_path__ + "img/icon-unlimited-dark.3a8bafe.svg";